(function ($) {
  /**
   * Filtering for issues.
   * When tab link is clicked hide/show items according to used filter.
   */
  $('.js-issues-nav-link').on('click', function (e) {
    e.preventDefault();

    var $this = $(this);
    var nav = $this.closest('.js-issues-nav');
    var grid = $this.closest('.js-issues').find('.js-issues-grid');
    var filterVal = $this.data('filter');

    nav.find('.is-active').removeClass('is-active');
    $this.parent().addClass('is-active'); // add class to item instead of current link

    if (filterVal == 'all') {
      // Show all items
      grid.find('.js-issues-grid-item').show('fast');
    } else {
      // When other filter is applied, hide items which don't have proper class
      grid
        .find(
          '.js-issues-grid-item:not(.js-issues-grid-item-' + filterVal + ')',
        )
        .hide('fast');

      // And show proper ones
      grid.find('.js-issues-grid-item-' + filterVal).show('fast');
    }
  });
})(jQuery);
